<template>
  <div class="scan">
    <div id="bcid"></div>
    <div @click="back" class="back">返回</div>
    <!-- <footer>
      <button @click="startRecognize">1.创建控件</button>
      <button @click="startScan">2.开始扫描</button>
      <button @click="cancelScan">3.结束扫描</button>
      <button @click="closeScan">4.关闭控件</button>
    </footer> -->
  </div>
</template>

<script>
/**
 * query 需传入query
 * message:错误提示信息
 * reg: 正则验证
 */
var scan = null

export default {
  props: {
    initStart: {
      type: Boolean
    }
  },
  data() {
    return {
      codeUrl: '',
      message:'',
      reg:''
    }
  },
  created(){
    if(this.$route.meta.backData){
      delete this.$route.meta.backData
    }
    this.message = this.$route.query.message || "二维码识别错误！"
    this.reg = this.$route.query.reg || ''
    
    var r = new RegExp(this.reg)
  },
  mounted(){
    this.startRecognize()
  },
  methods: {
    back(){
      this.$route.meta.backData = {
        str:287332519575727114
      }
      this.$router.go(-1)
    },
    // 创建扫描控件
    startRecognize() {
      let that = this
      scan = plus.barcode.create('barcode', [plus.barcode.QR], {
        top:'0',
        left:'0',
        width: document.body.clientWidth+'px',
        height: document.body.clientHeight+'px',
        position: 'static'
      });
      scan.onmarked = function(type, result){
        // alert('Success: type='+type+', result='+result);
        var r ;
        if(that.reg){
          r = new RegExp(that.reg).test(result + '')
        }else{
          r = true
        }
        if(type == 0 && r){
          that.$route.meta.backData = {
            str:result
          }
          that.$router.go(-1)
        }else{
          plus.nativeUI.alert(that.message, function(){
            scan.start();
          }, "提示", "确认");
        }
      };
      plus.webview.currentWebview().append(scan);
      scan.start();
    },
    // 开始扫描
    startScan() {
      if (!window.plus) return
      scan.start()
    },
    // 关闭扫描
    cancelScan() {
      if (!window.plus) return
      scan.cancel()
    },
    // 关闭条码识别控件
    closeScan() {
      if (!window.plus) return
      scan.close()
    }
  },
  beforeDestroy(){
    this.cancelScan()
    this.closeScan()
  },
  beforeRouteLeave(to, from, next) {
    next();
  }
}
</script>
<style lang="less">
  .scan {
    height: 100vh;
    position: fixed;
    width: 100vh;
    bottom: 0;
    right: 0;
    // height: 100%;
    .back{
      position: fixed;
      bottom: 0;
      right: 0;
    }
    #bcid {
      width: 100%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: calc(100% - 0.8rem);
      bottom:3rem;
      text-align: center;
      color: #fff;
    }
    footer {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 0.8rem;
      background-color: #fff;
      z-index: 2;
    }
  }
</style>